<template>
  <v-dialog persistent v-model="isDialogOpened" width="500">
    <v-card :class="`${arabic ? 'arFont' : 'enFont'}`">
      <v-card-title class="text-h5 grey lighten-2">
        {{ i18n.upload_new_document }}
      </v-card-title>
      <v-spacer></v-spacer>

      <v-card-text class="pt-5">
        <v-row no-gutters>
          <v-col cols="12">
            <v-select
              :class="`${arabic ? 'arFont' : 'enFont'}`"
              v-model="slug"
              item-text="ar"
              item-value="slug"
              :items="types"
              dense
              :label="i18n.document_type"
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12">
            <UploadFile
              :disabled="slug == null"
              :label="i18n.upload_new_document"
              prefix="document"
              :modelValue="uploadedFile"
              @update:modelValue="submitUploadedFile"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('closeDialog')">
          {{ i18n.close }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UploadFile from "@/components/uploadFile.vue";

export default {
  components: {
    UploadFile,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    types: Array,
  },
  data() {
    return {
      slug: null,
      uploadedFile: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
    isDialogOpened() {
      return this.dialog;
    },
  },
  methods: {
    submitUploadedFile(url) {
      this.uploadedFile = url;
      this.$emit("submitUploadedFile", this.uploadedFile, this.slug);
      this.uploadedFile = null;
      this.slug = null;
    },
  },
};
</script>
